import {useContext, useState} from 'react';
import axios from '../Common/axios';
import {getCompanyConfig} from '../Common/api';
import AppContext from '../../components/AppContext';


///////////////////////////////////////////////////////////////////
// 데이타 업데이트와 api연동 부분을 분리 작업 
///////////////////////////////////////////////////////////////////
export const useConfigValue = () => {
    const myContext = useContext(AppContext);

    const convertUnixTime = (unixTime) => {
        const date = new Date(unixTime * 1000);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        return {
            date: `${year}-${month}-${day}`,
            hour: `${hours}`,
            minu: `${minutes}`
        };
    };

    const updateCompanyConfig = async (res) => {
        myContext.setAssetGradeHigh(res.val_01);
        myContext.setAssetGradeRow(res.val_02);
        
        myContext.setRiskGrdHigh(res.val_03);
        myContext.setRiskGrdRow(res.val_04);

        myContext.setDoa(res.val_10);
        myContext.setCompanyCode(res.code_cd);
        myContext.setCompanyName(res.code_nm);   
        
        if(res.val_07){
            // 아래 코드는 에러남 
            // 정상적으로 진행하기 위해서는 App.js 파일일  setAppVersion.. 등 
            // 변수들을 추가해 줘야함 전역으로 사용하지 않아서 현재는 주석처리함.
            // res.val_07.split(",").map((item, index) => {
            //     if(index === 0){
            //         myContext.setAppVersion(item);
            //     }else if(index === 100){
            //         myContext.setAppUse(item);
            //     }else if(index === 1){
            //         myContext.setAppUrl(item);
            //     }else if(index === 2){
            //         // const appAutoDates = convertUnixTime(res.app_auto_date);
            //         // myContext.setAppAutoDate(appAutoDates.date);   
            //         // myContext.setAppAutoHour(appAutoDates.hour);   
            //         // myContext.setAppAutoMinu(appAutoDates.minu);  
            //         myContext.setAppAutoDate(item);
            //     }
            // });      
        }

    };

    const fetchAndUpdateConfig = async (pCompanyCode) => {
        try {
            const response = await axios.get(getCompanyConfig(pCompanyCode))
            await updateCompanyConfig(response.data);
            return response.data;
        } catch (error) {
            // console.error("Company config fetch error:", error);
            return false;
        }
    };

    return { updateCompanyConfig, fetchAndUpdateConfig};
};

// 위에 컴포넌트 사용할 때 아래처럼 사용
///////////////////////////////////////////////////////////////////
// import {useConfigValue}from '../ConfigValue/configData';
//
// const {fetchAndUpdateConfig} = useConfigValue();
// const handleSomeEvent = async () => {
//   const newConfigData = await fetchAndUpdateConfig(); // 새로운 설정 데이터를 가져오는 함수 
//   await updateCompanyConfig(newConfigData);
// };

// updateCompanyConfig만 사용하고 api는 다른것을 사용할 때
///////////////////////////////////////////////////////////////////
// import {useConfigValue} from '../ConfigValue/configData';
//
// const {updateCompanyConfig} = useConfigValue();
// const handleSomeEvent = async () => {
//   const newConfigData = await fetchNewConfigData(); // 새로운 설정 데이터를 가져오는 함수 
//   await updateCompanyConfig(newConfigData);
// };

